
import { Component, OnInit, Injector, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { Router, ActivatedRoute } from '@angular/router';
import { CompositeArrayComponent } from 'src/modules/base/components/composite-array/composite-array.component';
import { NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import BaseDecorator from 'src/modules/base/base-decorator';
import { FormService } from 'src/modules/base/components/form/form.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { SearchAndSelect } from 'src/modules/base/components/form/models/serachselect.model';
import { PopupFormComponent } from 'src/modules/base/components/popupform/popupform.component';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { event } from 'cypress/types/jquery';
import { ModalSize, SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { PrintService } from 'src/modules/base/shared/services/print.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { CashDenominationComponent } from '../cash-denomination/cash-denomination.component';
import PaymentModeFlagsDecorator from 'src/decorators/payment_mode_flags_decorator';

@Component({
    selector: 'app-refund',
    templateUrl: './refund.component.html',
    styleUrls: ['./refund.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: RefundComponent,
            multi: true,
        }],
    standalone: false
})
export class RefundComponent extends BaseDecorator implements OnInit {
  @Input() _value: any;
  @Input() bannerdata: any;
  @Input() refund_item: any;
  @Input() comp: any;
  @Input() zero_auth_scr: any;
  isOnline: boolean = false;
  public formService: FormService;
  public baseService: BaseService;
  self: any;
  refundByData: any;
  workflow_stage: any;
  err_message: any;
  show_pay_detail: boolean = true;
  show_refund_document: boolean = true;
  edit_g_data: any;
  time_for_otp_reset: boolean;
  check_refund: any;
  refund_detail_config: boolean = false;
  add_auth_data: any;
  is_online_checkbox_disabled: boolean = false;
  reasondatasource: any;
  question: SearchAndSelect;
  isPinRequired: boolean = false;
  ispinvalidate: boolean = false;
  u_id_data: any;
  cancel_bill_ws:boolean = false;
  is_transfer:boolean=false;
  printService: PrintService;
  defaultsetting: any;
  duplicatePaymentConfigResult: any;
  adding: any;
  zero_auth_config:boolean = false;
  payment_mode_code: any = "";
  payment_mode_display: any;
  bank_name: any;
  bank_code: any;
  amount: any;
  request_transaction_no: any;
  currency_exchange_remark: any;
  consultationAmountType: boolean = false;
  // remark_mandatory_config: boolean = false;
  priceForConsultation: any;
  variableXyz: boolean = true;
  refund_remark_mandatory_config_value: boolean;
   refund_documents: any ;
  patientBankDetailsVisible: any = "";
  cancel_check_box_visible: boolean = true;

  @Input()
  public set value(v: any) {
    if (v) {
      this._value = v;
    } else {
      this._value = '';
    }
  }
  @Input() public set dataRefund(value: any) {
    if (value) {
      this.currentData = value;
      if (this.currentData && this.currentData.is_online_refund) {
        this.isOnline = true;
      }
      console.log("Data Input ", this.currentData);
    }
  };
  @Output() buttonClick = new EventEmitter<any>();
  @Input() extraData: any;
  @Input() sendDataToChild: any;
  // payment detail json per screen so payment modes are restricted screen-wise
  @Input() paymentResource: string = 'payment_transaction_details';
  currentData: any = {};
  @ViewChild('compositeArrayComponent') compositeArrayComponent: CompositeArrayComponent;
  remark_mandatory_config_value: any;

  constructor(
    public router: Router,
    public injector: Injector,

    public alerts: AlertsService,
    public loader: LoaderService,
    public route: ActivatedRoute,
    public smartModalService: SmartModalService,
    public dialogService: DialogService,
    private preferenceService: PreferenceService
  ) {
    super(route, 'RefundComponent', injector);
    this.self = this;
    if (injector != undefined && injector.get != undefined) {
      this.formService = injector.get(FormService);
      this.baseService = injector.get(BaseService);
      this.printService = injector.get(PrintService)
    }
  }
  // refundreasonmulti = {
  // "datasource": {
  // "application": "facility-management",
  // "resource": "facility_master",
  // "query_id": "getReasonNameBasedOnReasonType",
  // "args": "facility_master_type:REASON,reasontype_id:refund",
  // "key": "id"
  // },
  // controls: {
  // refund_reason_name: {
  // value: ""
  // }
  // },
  // question: {
  // "getterKey": "name",
  // "getterValue": "name",
  // "req_keys": ["name"]
  // },
  // defaultsetting: {
  // "singleSelection": true,
  // "checkBoxRequired": false,
  // "closeDropDownOnSelection": true,
  // "apliCall": false
  // }
  // }

  ngOnInit() {
    PaymentModeFlagsDecorator.loadConfig(this.baseService, () => PaymentModeFlagsDecorator.hideGridColumns(this.compositeArrayComponent));
    if(!this.currentData?.refund_amount)
        this.getConfigforZeroAmount();
  if (this.bannerdata && this.bannerdata.patientType && (this.bannerdata.patientType =='IP' || this.bannerdata.patientType =='ER'|| this.bannerdata.patientType =='DC')) 
    {
      this.cancel_check_box_visible = false;
    }
    this.baseService.get('GET_CONFIG', 'module_code:billing,config_code:billing_821', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        if (result.errCode == 0) {
          if (result.resource[0].config_value == "no")
            this.is_online_checkbox_disabled = false;
          if (result.resource[0].config_value == "yes")
            this.is_online_checkbox_disabled = true;
        }
      })
    this.baseService.get('GET_CONFIG', 'module_code:billing,config_code:billing_825', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        console.log("res is....." + result)
        if (result.errCode == 0) {
          result = result.resource[0].config_value;
          if (result != "no") {
            this.refund_detail_config = true;
          } else {
            this.refund_detail_config = false;
          }
        }
      });
    this.baseService.get("GET_CONFIG", "module_code:emr,config_code:pin_required", "facility_config_mapping", "facility-management").subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0) {

        data.resource[0].multivalue.find(e => {
          if (e.id == "op_bill_refund") {
            this.ispinvalidate = true;
          }
          if(e.id=="op_pharmacy_refund"){
             this.isPinRequired = true;
          }

          
        })
      }
    })// <! ********************************check pin Code Config******************************************>
    this.check_refund = JSON.parse(sessionStorage.getItem('DatasourceData'));
    if (this.check_refund.is_approved_refund_completed == 2)
      this.show_pay_detail = true
     this.show_refund_document = true;
    //     if(this.bannerdata.payment_type=='Credit'|| this.bannerdata.payer_payment_type=='Credit'){
    //   if(this.currentData.refund_amount==0 && this.comp=='opRefund'|| this.comp=='walkinPharmacy'|| this.comp =='opticalRefund'){

    //     let s_of_r = this.comp == "walkinPharmacy" ? "PHARMACY COMPLETED BILL REFUND" : this.comp == "opRefund" ? "OP COMPLETED BILL REFUND" : "OPTICAL COMPLETED BILL REFUND";
    //   this.formService.baseService.get('GET_DATA_OF_WORKFLOW', 'flow_master:refund,authorization_amount:0'  + ",source_of_request:" + s_of_r, 'workflow_master_setup', 'facility-management').subscribe(
    //     resultodoc => {
    //       if (resultodoc.errCode == 0) {
    //         this.refundByData = resultodoc;
    //         var arr = this.refundByData.resource.find(e => {
    //           this.workflow_stage = e.workflow_stage;
    //           return e['workflow_stage'] == "multi_stage" || "single_stage";
    //         })
    //         if ((arr.workflow_stage == "multi_stage" || arr.workflow_stage == "single_stage") && this.check_refund.is_approved_refund_completed != 2) {
    //           this.show_pay_detail = false
    //         }
    //       }
    //       else {
    //         this.formService.alerts.error(resultodoc.message);
    //         this.err_message = resultodoc.message;
    //       }

    //     })
    //   }
    // }
    if (this.currentData.refund_amount || this.currentData.patient_refund_amount) 
     this.workflow_calling(); 
    this.reasondatasource = {
      "datasource": {
        "application": "facility-management",
        "resource": "facility_master",
        "query_id": "getReasonNameBasedOnReasonType",
        "args": "facility_master_type:REASON,reasontype_id:refund",
        "key": "id"
      },
      controls: {
        refund_reason_name: {
          value: ""
        }
      },
      question: {
        "getterKey": "name",
        "getterValue": "name",
        "req_keys": ["name"]
      },
      defaultsetting: {
        "singleSelection": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": false
      }
    }

    // let darg= "uhId:" + this.bannerdata.uhId + ",bill_no:" + this.bannerdata.bill_no + ",admissionId:" + this.bannerdata.admissionId
    // this.formService.baseService.get('CHECK_REFUND_OP', darg, 'refund_detail', 'billing').subscribe(
    // resultodoc => {
    // this.check_refund=resultodoc.resource[0]
    // if(this.check_refund.is_approved_refund_completed==3)
    // this.alerts.error(this.check_refund.authority_clearance_message);
    // })
    this.currentData.setAmount = this.currentData.refund_amount ? this.currentData.refund_amount : this.currentData.patient_refund_amount;
    this.currentData.timer = 30;
    this.currentData.otp_required = false;
    this.currentData.otp_verified = false;
    this.initCurrentData();
    if (this.comp != "opRefund") {
      this.getAuthorizedBy();
    }
    this.getRefundReasonName();
    this.checkDuplicatePaymentMode();
    this.getconfigforRemarkMandatory();
    this.getconfigForPatientBankDetail();
    console.log("Data Input ", this.data, this.currentData);
  }
  workflow_calling()
  {
       if ((this.currentData.refund_amount || (this.currentData.refund_amount == 0 && this.zero_auth_config)) || this.currentData.patient_refund_amount) {
      let s_of_r = this.comp == "walkinPharmacy" ? "PHARMACY COMPLETED BILL REFUND" : this.comp == "opRefund" ? "OP COMPLETED BILL REFUND" : "OPTICAL COMPLETED BILL REFUND";
      this.formService.baseService.get('GET_DATA_OF_WORKFLOW', 'flow_master:refund,authorization_amount:' + ((this.currentData.refund_amount || (this.currentData.refund_amount == 0 && this.zero_auth_config)) ? this.currentData.refund_amount : this.currentData.patient_refund_amount) + ",source_of_request:" + s_of_r, 'workflow_master_setup', 'facility-management').subscribe(
        resultodoc => {
          if (resultodoc.errCode == 0) {
            this.refundByData = resultodoc;
            var arr = this.refundByData.resource.find(e => {
              this.workflow_stage = e.workflow_stage;
              return e['workflow_stage'] == "multi_stage" || "single_stage";
            })
            if ((arr.workflow_stage == "multi_stage" || arr.workflow_stage == "single_stage") && this.check_refund.is_approved_refund_completed != 2) {
              this.show_pay_detail = false
            }
             if ((arr.workflow_stage == "multi_stage" || arr.workflow_stage == "single_stage") && this.check_refund.is_approved_refund_completed != 2) {
              this.show_refund_document = false
            }
          }
          else {
            this.formService.alerts.error(resultodoc.message);
            this.err_message = resultodoc.message;
          }

        })

    }
  }
  getConfigforZeroAmount()
  {
      this.baseService.get("GET_CONFIG", "module_code:billing,config_code:billing_896", "facility_config_mapping", "facility-management").subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0) {
          data.resource[0].multivalue.find(e => {
          if ((e.id != "no" && e.id === this.zero_auth_scr) || (e.id != "no" && e.id === "all")) {
            this.zero_auth_config = true;
            return;
          }
        })
        if(this.zero_auth_config)
          this.workflow_calling();
      }
    })
  }
  refundamnt(e) {

  }
  transferToUHID(e)
  { 
    this.currentData.paymentSum = 0;
   if (e.target.checked) {
  this.is_transfer=true;
  this.currentData.payment_details = [];
  } else {
this.is_transfer=false;
this.currentData.setAmount = this.currentData.refund_amount;
  }
  }

  getconfigForPatientBankDetail() {
    this.baseService.get('GET_CONFIG', 'module_code:payment,config_code:payment_155', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        console.log("res is....." + result)
        if (result.errCode == 0 && result.resource.length > 0) {
          this.patientBankDetailsVisible = result.resource[0].config_value;
        }
      });
  }

   getconfigforRemarkMandatory() {
    this.baseService.get('GET_CONFIG', 'module_code:facility-management,config_code:facility_mgnt_0011', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        console.log("res is....." + result)
        if (result.errCode == 0 && result.resource.length > 0) {
          this.remark_mandatory_config_value = result.resource[0].multivalue;
          this.remark_mandatory_config_value.find(e => {
            if (e.id == 'refund') {
              this.refund_remark_mandatory_config_value = true;
            }
          });
        }
      });
  }

  checkDuplicatePaymentMode() {
    this.baseService.get('GET_CONFIG', 'module_code:payment,config_code:payment_100', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        if (result.errCode == 0 && result.resource.length > 0) {
          this.duplicatePaymentConfigResult = result.resource[0].config_value
        }
      });
  }
  checkIsOnline() {
    if (this.currentData && this.currentData.is_online_refund) {
      this.show_pay_detail = false;
      this.currentData.is_online_refund = true;
    } else {
      this.currentData.is_online_refund = false;
      this.show_pay_detail = true;
    }
  }
  initCurrentData() {
    this.currentData.authorised_by_id = ''
    this.currentData.paymentSum = 0;
    if(this.check_refund && this.check_refund.is_approved_refund_completed != 2)
    {
    this.currentData.refund_receiver_name = '';
    this.currentData.refund_receiver_contact_number = '';
    this.currentData.account_no = '';
    this.currentData.ifsc_code = '';
    this.currentData.beneficiary_name = '';
    this.currentData.branch_name = '';

    }
    // this.currentData.remarks = '';
    // this.currentData.refund_reason_name = ''
  }

  getAuthorizedBy() {
    let data = {
      application: "facility-management",
      resource: "authority_master",
      query_id: "GET_AUTHORIZED",
      args: "authorized_for:Refund"
    }
    this.baseService.getByDataSource(data).subscribe(res => {
      if (res.errCode == 0) {
        this.currentData.authorizedData = res.resource;
      }
    });
  }


  getRefundReasonName() {
    let data = {
      application: "facility-management",
      resource: "facility_master",
      query_id: "getReasonNameBasedOnReasonType",
      args: "facility_master_type:REASON,reasontype_id:refund",
    }
    this.baseService.getByDataSource(data).subscribe(res => {
      if (res.errCode == 0) {
        // this.currentData.refundReasonName = res.resource;
      }
    });
  }

  getAuthorisedName(event) {
    if(event.target.value == ''){
      this.currentData.otp_required = false;
      this.currentData.otp_verified = false;
    }
    else{
    this.time_for_otp_reset = true
    let author = this.refundByData.resource.find(val => {
      return val.userId == event.target.value;
    });
    this.countdown(30);

    this.currentData.authorised_by = author.userName;
    this.currentData.authorized_by_mobile_no = author.contact_no;
    this.currentData.authorized_by_email_id = author.email_id;
    this.authorizationAction('refund');
    console.log("Author is ", author);
  }
}

  getRefundReason(event) {
    let author = this.currentData.refundReasonName.find(val => {
      return val.id == event.target.value;
    });
    this.currentData.refund_reason = author.name;
    console.log("Author is ", author);
  }

  authorizationAction(type) {
    this.currentData.otp_verified = false;
    this.u_id_data = this.refundByData.resource.find(e => {
      return this.currentData.authorised_by_id == e.userId
    })

    this.loader.showSpinner();
    let result = {
      "authorized_by_id": this.currentData.authorised_by_id,
      "authorized_by": this.currentData.authorised_by,
      "uhId": this.extraData.uhId,
      "transaction_type": this.extraData.transaction_type,
      "authorized_type": type,
      "patient_type": this.extraData.patient_type,
      "authorized_amount": this.currentData.refund_amount,
      "total_amount": this.bannerdata.net_amount
    }
    result['flow_master'] = "refund";
    result['']
    result['source_of_request'] = this.comp == "walkinPharmacy" ? "PHARMACY COMPLETED BILL REFUND" : this.comp == "opRefund" ? "OP COMPLETED BILL REFUND" : "OPTICAL COMPLETED BILL REFUND";
    //if(this.obj_val.form.controls.refunded_orderId)
    //result['receipt_no']=this.obj_val.form.controls.refunded_orderId.value;
    result['workflow_stage'] = this.workflow_stage;
    result['uhId'] = this.bannerdata.uhId;
    result['bill_no'] = this.bannerdata.bill_no;
    result['admissionId'] = this.bannerdata.admissionId;
    // if(this.obj_val.form.controls.refund_amount)
    result['flow_amount'] = this.currentData.refund_amount
    //if(this.obj_val.form.controls.refunded_available_amount)
    result['total_amount'] = this.currentData.refund_amount
    result['refund_items'] = this.refund_item
    result["refund_detail"] = { ...result }
    if (this.currentData.authority_clearance) {
      result["advance_refund"]["transaction_type"] = "OP Billing";
      result["advance_refund"]["refunded_receipt_date_time"] = this.currentData.authority_clearance.refunded_receipt_date_time
      result["advance_refund"]["refunded_receipt_amount"] = this.currentData.authority_clearance.refunded_receipt_amount
      result["advance_refund"]["refunded_available_amount"] = this.currentData.authority_clearance.refunded_available_amount
    }
    // result.advance_refund.push(this.refund_Submit)
    result["authority_checkpoints"] = [this.refundByData.resource.find(e => {
      return e['userId'] == this.currentData.authorised_by_id;
    })]
    if (this.workflow_stage == "otp_based" && this.u_id_data.otp_required) {
      this.baseService.action(result, 'ADD_AUTHORITY_CLEARANCE', 'billing', 'authority_clearance').subscribe(
        (data: any) => {

          console.log("Response from ADD_DISCOUNT_AUTHORITY ", data);
          if (data.errCode == 0 && data.resource.length > 0) {
            this.add_auth_data = data.resource[0];
            this.currentData.otp_required = data.resource[0].isOtp_required;
            this.currentData.checkedAuthorization = true;
            if (this.currentData.otp_required)
              this.currentData.otp = ''
            this.time_for_otp_reset = false
            this.countdown(30);
          } else {
            this.currentData.checkedAuthorization = false;
            this.currentData.otpMessage = data.message;
            this.alerts.error(data.message);
          }
          this.loader.hideSpinner();
        });
    }
    else {
      this.loader.hideSpinner();
      this.currentData.otp_required = false;
      this.currentData.otp_verified = false;
    }
  }
  countdown(x) {
    if (this.time_for_otp_reset) {
      return
    }
    if (x === 0) {
      this.currentData.timer = x;
      return;
    }
    return setTimeout(() => { this.currentData.timer = x; this.countdown(--x); }, 1000)
  }
  checkOTP(event, type) {
    console.log("Event is ", event.target.value);
    this.loader.showSpinner();
    let result = {
      "authorized_by_id": this.currentData.authorised_by_id,
      "authorized_by": this.currentData.authorised_by,
      "otp": event.target.value,
      "uhId": this.extraData.uhId,
      "id": this.add_auth_data ? this.add_auth_data.id : "",
      "transaction_type": this.extraData.transaction_type,
      "authorized_type": type,
      "patient_type": this.extraData.patient_type,
      "authorized_amount": this.currentData.refund_amount
    }
    result['flow_master'] = "refund";
    result['']
    result['source_of_request'] = this.comp == "walkinPharmacy" ? "PHARMACY COMPLETED BILL REFUND" : this.comp == "opRefund" ? "OP COMPLETED BILL REFUND" : "OPTICAL COMPLETED BILL REFUND";
    //if(this.obj_val.form.controls.refunded_orderId)
    //result['receipt_no']=this.obj_val.form.controls.refunded_orderId.value;
    result['workflow_stage'] = this.workflow_stage;
    result['uhId'] = this.bannerdata.uhId;
    result['bill_no'] = this.bannerdata.bill_no;
    result['admissionId'] = this.bannerdata.admissionId;
    // if(this.obj_val.form.controls.refund_amount)
    result['flow_amount'] = this.currentData.refund_amount
    //if(this.obj_val.form.controls.refunded_available_amount)
    result['total_amount'] = this.currentData.refund_amount
    result['refund_items'] = this.refund_item
    result["refund_detail"] = { ...result }
    if (this.currentData.authority_clearance) {
      result["advance_refund"]["transaction_type"] = "OP Billing";
      result["advance_refund"]["refunded_receipt_date_time"] = this.currentData.authority_clearance.refunded_receipt_date_time
      result["advance_refund"]["refunded_receipt_amount"] = this.currentData.authority_clearance.refunded_receipt_amount
      result["advance_refund"]["refunded_available_amount"] = this.currentData.authority_clearance.refunded_available_amount
    }
    // result.advance_refund.push(this.refund_Submit)
    result["authority_checkpoints"] = [this.refundByData.resource.find(e => {
      return e['userId'] == this.currentData.authorised_by_id;
    })]
    this.baseService.action(result, 'VERIFY_OTP', 'billing', 'authority_clearance').subscribe(
      (data: any) => {
        console.log("Response from VERIFY_OTP ", data);
        if (data.errCode == 0 && data.resource.length > 0) {
          this.currentData.otp_verified = true;
          this.alerts.success("OTP Verified");
        } else {
          this.currentData.otp = ''
          this.currentData.otp_verified = false;
          this.currentData.otpMessage = data.message;
          this.alerts.error(data.message);
        }
        this.loader.hideSpinner();
      });
  }

  openCashPopup(event) {
    let data = {
      da: event.items[event.index], index: event.index

    }
    this.smartModalService.open(CashDenominationComponent, data, "", ModalSize.Sm, "hide").subscribe(
      result => {
        const key = "cash_DenData";

        let existingData = sessionStorage.getItem(key);

        let parsedData = existingData ? JSON.parse(existingData) : {};

        parsedData[result.result.index] = result.result;

        sessionStorage.setItem(key, JSON.stringify(parsedData));
      })
  }


  OnPaymentAdd(event) {
    PaymentModeFlagsDecorator.hideGridColumns(this.compositeArrayComponent);
    if (event.action == "info") {
      this.openCashPopup(event);

    }
    else {
    if (this.comp == "opRefund" && this.payment_mode_code != "cash" && this.payment_mode_code != "pos") {
      // `event.items` can be empty (a delete emits before the rows are re-propagated), so
      // resolve the last row once and only pre-fill it when it actually exists. console error fix
      const lastRow = event.items && event.items.length > 0 ? event.items[event.items.length - 1] : undefined;
      if (lastRow) {
        if (lastRow.bank_code == undefined && this.bank_code != "" && this.bank_code != undefined) {
          lastRow.bank_code = this.bank_code
        }
        if (lastRow.bank_name == undefined && this.bank_name != "" && this.bank_name != undefined) {
          lastRow.bank_name = this.bank_name
        }
        if (lastRow.request_transaction_no == undefined && this.request_transaction_no != "" && this.request_transaction_no != undefined) {
          lastRow.request_transaction_no = this.request_transaction_no
        }
      }
    }
    if (event.items.length > 0 || event.action == 'delete') {
      if (event.items != undefined && event.items.length > 0 && this.duplicatePaymentConfigResult == 'no') {
        for (let i = 0; i < event.items.length - 1; i++) {
          let element = event.items[i];
          if (element['payment_mode_code'] == event.items[event.items.length - 1].payment_mode_code) {
            this.compositeArrayComponent.removeRow(event.items.length - 1);
            this.alerts.error('Same payment mode can not accept multiple times');
          }
        };
      }
      else if (this.duplicatePaymentConfigResult && this.duplicatePaymentConfigResult == 'yes') {
        let i = 0;
        const transactionMap = new Map();
        if (event.items && event.items.length > 0)
          event.items.forEach(element => {
            if (element.payment_mode_display == 'Cash') {
              i = i + 1
              this.adding = i
            }
            else {
              const txnNo = (element.transaction_no || element.request_transaction_no || '').toString().trim();
              const bankId = (element.bank_id || element.bank_code || '').toString().trim();
              const key = `${txnNo}_${bankId}`;
              if (txnNo && bankId && transactionMap.has(key)) {
                this.compositeArrayComponent.removeRow(event.items.length - 1);
                this.formService.alerts.error('Duplicate bank name and transaction number combinations are not allowed.');
                return;
              }
    transactionMap.set(key, true);
  }
          });
        if (this.adding && this.adding > 1) {
          this.compositeArrayComponent.removeRow(event.items.length - 1);
          this.formService.alerts.error('Same payment mode cant not accept multiple times');
        }
      }
      // console.log("Event is ",event);
      if (event.type != 'delete') {
        let sum = 0;
        event.items.forEach(element => {
          sum += Number(element.amount)
        });
        if (event.items.length > 0 && event.items[event.items.length - 1].amount == 0) {
          this.compositeArrayComponent.removeRow(event.items.length - 1);
          this.alerts.error("Amount Added must be greater than 0");
        }
        if (sum.toFixed( this.formService.appService._currentSessionData.currency_decimal_limit? this.formService.appService._currentSessionData.currency_decimal_limit: 2) <= (this.currentData.refund_amount ? this.currentData.refund_amount : this.currentData.patient_refund_amount)) {
          this.currentData.paymentSum = sum.toFixed( this.formService.appService._currentSessionData.currency_decimal_limit? this.formService.appService._currentSessionData.currency_decimal_limit: 2);
          this.currentData.payment_details = event.items;
          this.syncPaymentAmount();
        } else {
          if (event.items.length == 0) {

          }
          else {
            this.compositeArrayComponent.removeRow(event.items.length - 1);
            this.alerts.error("Refund amount can't be more than net amount");
          }
        }
      }
    }
    }}
  /**
   * Keeps `setAmount` (what is still to be paid out) and the payment grid's `amount` pre-fill
   * in step, without rebuilding the grid.
   *
   * `setAmount` used to be bound to the payment array's [dependentField]. Any change there
   * makes composite-array's ngDoCheck call setFormFields(), which sets showPage = false and
   * re-runs its ngOnInit asynchronously - and showPage is restored only from getResourceDef's
   * success branch, which answers false when requests for the same resource overlap. So a
   * payment add could leave the whole grid unrendered with no way back (#171375). The old
   * 500 / 1500 ms setTimeout here existed only to time that teardown, and could not fix it.
   *
   * propagateDependentMapValue is the array's own in-place path (built for
   * [dependentFieldMap]): it updates the field default, the question and the live control
   * with emitEvent: false, so nothing is torn down and no cascade is re-triggered.
   */
  syncPaymentAmount() {
    const decimals = this.formService.appService._currentSessionData.currency_decimal_limit
      ? this.formService.appService._currentSessionData.currency_decimal_limit : 2;
    // refund_amount 0 is a real value (#204188): opRefund sends no patient_refund_amount, so the
    // truthy fallback gave Number(undefined) = NaN and left the payment_transaction_details amount blank
    const refundable = this.currentData.refund_amount ? this.currentData.refund_amount : (this.currentData.patient_refund_amount ?? this.currentData.refund_amount);
    const outstanding = Number(refundable) - Number(this.currentData.paymentSum ? this.currentData.paymentSum : 0);
    this.currentData.setAmount = outstanding == 0 ? (0).toFixed(decimals) : outstanding;
    if (this.compositeArrayComponent) {
      this.compositeArrayComponent.propagateDependentMapValue('amount', this.currentData.setAmount);
    }
    return this.currentData.setAmount;
  }
  /**
   * The flat add-form emits (getData) whenever it is built or rebuilt - including after each
   * clearOnSave - and composite-array captures its childForm before re-emitting, so this is
   * the first point at which the `amount` control exists. It carries the initial pre-fill that
   * replaceDependentValue() used to do during a full re-init, now that [dependentField] is gone.
   */
  onPaymentFormReady(event) {
    const amount = this.syncPaymentAmount();
    // Write straight into the form this event carries, rather than relying on the
    // propagateDependentMapValue call inside syncPaymentAmount(). The flat form emits this from
    // inside the array's OWN view creation, so @ViewChild('compositeArrayComponent') is still
    // undefined the first time round and that call silently no-ops - which left `amount` blank
    // on the first row. buildFormGroup maps field.default -> question.value -> the control, so
    // once the ViewChild does resolve the default carries later rebuilds; this covers the rest.
    const built = event && event.obj ? event.obj.form : undefined;
    if (!built) {
      return;
    }
    if (event.type == 'form') {
      if (built.controls && built.controls['amount']) {
        built.controls['amount'].setValue(amount, { emitEvent: false });
      }
    } else if (event.type == 'mapping' && built['amount']) {
      built['amount'].value = amount;
    }
  }
  onApprovalDocumentUpload(event: any) {
    if (event && event.data && event.data.documentId) {
      this.currentData['approval_document_id'] = event.data.documentId;
      this.currentData['approval_document_name'] = event.data.documentName;
    }
  }
   onDocumentAdd(event){
    if(event && event.items && event.items.length > 0 && event.items[0].folder_name != undefined){
      this.refund_documents = event.items;
    }
  }
  valueChangeStart(e: any, obj) {
    if (this.variableXyz) {
      this.variableXyz = false;
      if (e.question && e.question.key == "amount" && e.question.block_id == "payment") {
        if (this.sendDataToChild) {
          e.question.pattern = this.formService.appService._currentSessionData.currency_decimal_limit? this.preferenceService.currencyPattern() : "^\\d{1,9}(\\.\\d{1,2})?$";
        } else {
          e.question.pattern = this.formService.appService._currentSessionData.currency_decimal_limit? this.preferenceService.currencyPattern() : "^[0-9+]*$";
        }
      }
    }
    if(obj?.form?.controls?.['payment_mode_code']?.question_component?.question?.options){
      let val = obj?.form?.controls?.['payment_mode_code'].question_component.question.options.filter(x => x.code == "pos");
      if(val.length > 0){
        for (let mode in obj.form.controls['payment_mode_code'].question_component.question.options) {
          if (obj.form.controls['payment_mode_code'].question_component.question.options[mode].code == "pos") {
            obj.form.controls['payment_mode_code'].question_component.question.options.splice(mode, 1);
            break;
          }
        }
      }
  }
    if (obj?.form?.controls?.['payment_mode_code']?.value == "cash" && obj?.form?.controls?.['bank_code']?.question_component != undefined) {
      obj.form.controls['bank_code'].question_component.question.visible = false;
    }
    if (obj?.form?.controls?.['bank_code']?.question_component) {
      if (obj.form.controls['payment_mode_code'] != undefined) {
        if (obj.form.controls['payment_mode_code'].value == "cheque" || obj.form.controls['payment_mode_code'].value == "dd" || obj.form.controls['payment_mode_code'].value == "rtgs" || obj.form.controls['payment_mode_code'].value == "neft") {
          if (obj.form.controls['bank_code'] != undefined)
            obj.form.controls['bank_code'].question_component.question.required = true;
        }
        else
          obj.form.controls['bank_code'].question_component.question.required = false;
      }
    }
  }
  onPaymentRemove(event) {
    console.log("Event is ", event);
  }

  createBill(e) {
    this.currentData['refund_documents'] = this.refund_documents;
    this.currentData['transfer_to_uhid']=this.is_transfer;
    if(this.comp == "opRefund")
    this.currentData['refund_bill_without_service'] =this.cancel_bill_ws;
    // console.log("Event is ",e, this.currentData);
    if (e == 'cancel') {
      this.buttonClick.emit({transfer_to_uhid:this.is_transfer, type: e, current: this.currentData, condition: this.show_pay_detail, check_refund: this.check_refund, r_by_data: this.refundByData, workfrow_s: this.workflow_stage, error: this.is_transfer ? undefined : this.err_message })
    } else if (e == 'submit') {
      if (this.currentData) {
        if (this.currentData.refund_amount == 0) {
          if (this.refund_detail_config) {
            if ((!this.currentData.refund_receiver_contact_number || !this.currentData.refund_receiver_name) && !this.is_transfer) {
              this.alerts.error("Please fill mandatory fields");
              return false
            }
          }
          if (this.refund_remark_mandatory_config_value) {
            if (this.currentData.refund_reason != undefined && this.currentData.refund_reason == "") {
              this.alerts.error("Please fill the refund reason");
              return false
            }
            else if ((this.currentData.remarks == '' || this.currentData.remarks == undefined) && this.check_refund && this.check_refund.is_approved_refund_completed != 2) {
              this.alerts.error("Please add remarks to proceed");
              return false
            }
          }
          if (this.refundByData)
            this.buttonClick.emit({ transfer_to_uhid:this.is_transfer, type: e, current: this.currentData, condition: this.show_pay_detail, check_refund: this.check_refund, r_by_data: this.refundByData, workfrow_s: this.workflow_stage, error: this.is_transfer ? undefined : this.err_message });
          else{
            if(this.ispinvalidate==true){
              this.validatePin(e)
            }
            else{
              this.buttonClick.emit({ transfer_to_uhid:this.is_transfer, type: e, current: this.currentData, condition: this.show_pay_detail, check_refund: this.check_refund, r_by_data: this.refundByData, workfrow_s: this.workflow_stage, error: this.is_transfer ? undefined : this.err_message });
            }
          
          }
        }

        else {
          if (((this.currentData.refund_amount ? this.currentData.refund_amount : this.currentData.patient_refund_amount) == this.currentData.paymentSum) || !this.show_pay_detail || this.currentData.is_online_refund || this.is_transfer) {
            if (this.currentData.checkedAuthorization != undefined && !this.currentData.checkedAuthorization && this.show_pay_detail && (!this.check_refund || (this.check_refund && this.check_refund.is_approved_refund_completed != 2))) {
              this.alerts.error(this.currentData.otpMessage ? this.currentData.otpMessage : 'Please fill required fields.');
            }
            else if (this.currentData.otp_required && !this.currentData.otp_verified) {
              this.alerts.error("Please verify OTP and Proceed");
            }
            else if ((this.currentData.authorised_by_id == '' || this.currentData.authorised_by_id == undefined) && this.check_refund.is_approved_refund_completed != 2 && !this.is_transfer) {
              this.alerts.error("Please select Refund By");
            }
            else if (this.refund_remark_mandatory_config_value && this.currentData.refund_reason == "") {
              this.alerts.error("Please fill the Refund reason");
            }
            else if (this.refund_detail_config && this.currentData.refund_receiver_name == "" && !this.is_transfer) {
              this.alerts.error("Please fill mandatory fields");
            }
            else if (this.refund_detail_config && this.currentData.refund_receiver_contact_number == "" && !this.is_transfer) {
              this.alerts.error("Please fill mandatory fields");
            }
            else if ((this.currentData.remarks == '' || this.currentData.remarks == undefined) && this.check_refund && this.check_refund.is_approved_refund_completed != 2) {
              this.alerts.error("Please add remarks to proceed");
            }
            else if (this.isPinRequired == true && this.comp == "walkinPharmacy" && this.currentData.remarks && this.check_refund && this.check_refund.is_approved_refund_completed != 2) {
              this.validatePin(e)
              return false
            }
            else if (this.ispinvalidate == true &&  this.comp == "opRefund" && this.currentData.remarks && this.check_refund && this.check_refund.is_approved_refund_completed != 2) {
              this.validatePin(e)
              return false
            }
            else {
              this.buttonClick.emit({ transfer_to_uhid:this.is_transfer, type: e, current: this.currentData, condition: this.show_pay_detail, check_refund: this.check_refund, r_by_data: this.refundByData, workfrow_s: this.workflow_stage, error: this.is_transfer ? undefined : this.err_message });
            }

          }
          else if (this.currentData.is_online_refund == true) {
            if ((this.currentData.authorised_by_id == '' || this.currentData.authorised_by_id == undefined) && this.check_refund.is_approved_refund_completed != 2) {
              this.alerts.error("Please select Refund By");
            }
            else if (this.currentData.remarks == '' || this.currentData.remarks == undefined && this.check_refund && this.check_refund.is_approved_refund_completed != 2) {
              this.alerts.error("Please add remarks to proceed");
            }
            else {
              this.buttonClick.emit({ transfer_to_uhid:this.is_transfer, type: e, current: this.currentData, condition: this.show_pay_detail, r_by_data: this.refundByData, check_refund: this.check_refund, workfrow_s: this.workflow_stage });
            }
          }
          else {
            this.alerts.error("Please Pay Refundable Amount and then Proceed");
          }
        }
      }
    return true

    }
  }

  afterSubmitReqSuccess(event, response, formComponent): Boolean {
    console.log("afterSubmitReqSuccess ", event, response, formComponent);
    if (event.currentBtnVal.action == "print" && this.form.controls["payment_detail"]['question_component'].question.visible == false) {
        delete event.currentBtnVal.action;
        delete event.currentBtnVal.file_data;
    }
    return true

}
cancelBillWS(e)
{
  if (e.target.checked) 
 this.cancel_bill_ws=true;
 else 
this.cancel_bill_ws=false;
}
  reasonSelect(event) {
    this.currentData.refund_reason = event.alldata.name

    this.currentData.refund_reason_Id = event.id
  }
  reasonDeselect(event) {
    this.currentData.refund_reason = ''
    this.currentData.refund_reason_Id = ''
  }
  valueChangeEnd(e: any, formObj) {
    PaymentModeFlagsDecorator.applyFlags(e, formObj);
    PaymentModeFlagsDecorator.hideGridColumns(this.compositeArrayComponent);
    if (this.comp == "opRefund" && this.payment_mode_code == "") {
      if (this.currentData && this.currentData.payment_mode_code && e && e.question && e.question.key == "payment_mode_display" && formObj.form.controls.bank_code?.question_component && formObj.form._manualChange == false) {
        formObj.form.controls['payment_mode_code'].setValue(this.currentData.payment_mode_code)
        if (this.currentData.payment_mode_code == "pos") {
          formObj.form.controls['payment_mode_code'].setValue("cash")
        }
        else{
          formObj.form.controls['payment_mode_display'].setValue(this.currentData.payment_mode_display)
        }
        if (this.currentData.payment_mode_code != "cash" && this.currentData.payment_mode_code != "pos" && formObj.form.controls.bank_code.question_component) {
          formObj.form.controls.bank_code.question_component.question.datasource = { application: "facility-management", resource: "facility_master", query_id: "getOrganizationSetup", args: "payment_mode_code:" + formObj.form.controls['payment_mode_code'].value + ",facility_master_type:PAYMENTMODEMAPPING" }
          formObj.form.controls.bank_code.question_component.question = {
            ...formObj.form.controls.bank_code.question_component.question,
            visible: true
          };
          formObj.form.controls.request_transaction_no.question_component.question = {
            ...formObj.form.controls.request_transaction_no.question_component.question,
            visible: true
          };
          formObj.form.controls.request_transaction_no.question_component.question = {
            ...formObj.form.controls.request_transaction_no.question_component.question,
            disabled: false
          };
          setTimeout(() => {
            if (formObj.form.controls['payment_mode_code'].value == "cheque" || formObj.form.controls['payment_mode_code'].value == "dd" || formObj.form.controls['payment_mode_code'].value == "rtgs" || formObj.form.controls['payment_mode_code'].value == "neft") {
              if (formObj.form.controls['bank_code'] != undefined) {
                formObj.form.controls.bank_code.setErrors({ required: true });
                formObj.form.controls.bank_code.setValidators([Validators.required])
              }
            }
            formObj.form.controls.request_transaction_no.enable({ emitEvent: false });
            formObj.form.controls.request_transaction_no.setErrors({ required: true });
            formObj.form.controls.request_transaction_no.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(40)])
            formObj.form.controls.request_transaction_no.updateValueAndValidity();
          });
        }
      }
    }
    if (e.question && e.question.key == "amount" && (formObj.id == this.paymentResource || formObj.id == "main") && formObj.form.controls['amount']) {
      if (this.sendDataToChild) {
        e.question.pattern = this.formService.appService._currentSessionData.currency_decimal_limit? this.preferenceService.currencyPattern() :"^\\d{1,9}(\\.\\d{1,2})?$";
        let amountFinal = Number(formObj.form.controls['amount'].value);
        formObj.form.controls['amount'].setValue(amountFinal.toFixed( this.formService.appService._currentSessionData.currency_decimal_limit? this.formService.appService._currentSessionData.currency_decimal_limit: 2));
      } else {
        e.question.pattern =this.formService.appService._currentSessionData.currency_decimal_limit? this.preferenceService.currencyPattern() : "^[0-9+]*$";
      }
    }
    if (this.comp === 'walkinPharmacy' &&
      e?.question?.key === 'payment_mode_code' &&
      formObj.form._manualChange == false &&
      this.currentData?.payment_mode_code) {
      const ctrl = formObj?.form?.controls?.['payment_mode_code'];
      const isPosMode = this.currentData.payment_mode_code === 'pos';
      const effectiveCode = isPosMode ? 'cash' : this.currentData.payment_mode_code;
      if (formObj?.id == this.paymentResource && ctrl && ctrl.value !== effectiveCode) {
        setTimeout(() => {
          if (ctrl.value !== effectiveCode) {
            ctrl.setValue(effectiveCode);
            ctrl.updateValueAndValidity();
            const qc = ctrl?.['question_component'];
            let selectedOption: any;
            if (qc) {
              selectedOption = qc.question?.options?.find(
                (x: any) => x[qc.question.getterKey] === effectiveCode
              );
              qc.updateDependentValue(selectedOption || effectiveCode);
            }
            const paymentModeDisplayCtrl = formObj?.form?.controls?.['payment_mode_display'];
            if (paymentModeDisplayCtrl) {
              const effectiveDisplay = isPosMode
                ? (selectedOption ? selectedOption['display'] : effectiveCode)
                : this.currentData.payment_mode_display;
              if (effectiveDisplay) {
                paymentModeDisplayCtrl.setValue(effectiveDisplay);
              }
            }
          }
        });
      }
    }
    if (e != undefined && e.question != undefined && e.question.key != undefined && e.question.key == "payment_mode_code") {
      if (formObj.form.controls['payment_mode_code'] != undefined && formObj.form.controls['payment_mode_code'].value != "cash" && formObj.form.controls['bank_code'] != undefined && formObj.form.controls['bank_code'].question_component != undefined) {

        formObj.form.controls['bank_name'].status = "VALID";
        formObj.form.controls['bank_code'].status = "VALID";
        let data = {
          'args': `payment_mode_code:${formObj.form.controls['payment_mode_code'].value},facility_master_type:PAYMENTMODEMAPPING`
        }

        var queryId = "getOrganizationSetup"
        this.formService.baseService.getData(data, "", "facility_master", "facility-management", queryId).subscribe(res => {
          if (res.errCode == 0 && res.resource.length > 0) {
            formObj.form.controls['bank_code'].question_component.question.options = res.resource;


          } else {
            formObj.form.controls['bank_code'].question_component.question.options = [];
            if (formObj.form.controls['bank_name'].value != "") {
              formObj.form.controls['bank_name'].setValue("");
              formObj.form.controls['bank_name'].status = "VALID";
            }

            if (formObj.form.controls['bank_code'].value != "") {
              formObj.form.controls['bank_code'].setValue("");
              formObj.form.controls['bank_code'].status = "VALID";
            }

          }

        })

      }
    }

  }
  handleFile(action, obj, callback = null) {
    //action = action.currentBtnVal;
    if (action.file_data != undefined) {
      var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
      var fileObj = JSON.parse(JSON.stringify(action.file_data));
      fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
      fileObj.resource = fileObj.resource != undefined ? fileObj.resource : "this._currentData.resource";
      fileObj.args = fileObj.args != undefined ? this.formService.baseService.buildDyanamicStr(fileObj.args, obj) : false;
      fileObj.filter = fileObj.filter != undefined ? this.formService.baseService.buildDyanamicStr(fileObj.filter, obj) : false;
      this.formService.baseService.handleFile(fileObj, async (fileData) => {
        if (fileData) {
          if (fileData.type == "application/json") {
            try {
              var response = await fileData.text();
              response = JSON.parse(response);
              if (response.errCode == -1 && response.message != undefined) {
                this.formService.alerts.error(response.message);
              }
              console.log(response);
            } catch (e) {
              this.formService.alerts.error('API error');
            }
          } else {
            fileObj.key = key;
            this.printService.handleFileReponse(fileObj, action.action, fileData, callback);
          }
        } else {
          this.formService.alerts.error('server error');
          if (callback) {
            callback(false);
          }

        }
      });
    } else {
      console.error("Please provide File Data");
      if (callback) {
        callback(false);
      }
    }
  }

  validatePin(event) { //validate password or pin
    var currentBtnVal
    let popObj = {
      "data": [], "action": "ADD", "getdata": true, "layout_type": "simple", "application": "emr",
      "title": 'Validate PIN',
      "size": DialogModalSize.Sm,
      "resource": 'op_validate_pin',
      "customButton": {
        "Add": [
          {
            "label": "button.confirm",
            "icon": "fa fa-check"
          }
        ]
      }
    }
    this.dialogService.open(PopupFormComponent, popObj).afterClosed.subscribe(response => {
      if (response && response.result && response.result.pin) {
        this.loader.showSpinner();
        let inputPin = response.result.pin
        this.formService.baseService.action({ pin: inputPin }, "authenticate_pin", "account-management", "manage_user_pin").subscribe(res => {
          if (res.errCode == 0) {
            if (res && res.resource && res.resource.length > 0) {
              let isAuth = res.resource[0].is_authorised;
              if (isAuth) {
                let e = "submit"
                this.buttonClick.emit({ transfer_to_uhid:this.is_transfer, type: e, current: this.currentData, condition: this.show_pay_detail, check_refund: this.check_refund, r_by_data: this.refundByData, workfrow_s: this.workflow_stage, error: this.is_transfer ? undefined : this.err_message });
                if (this.comp != "walkinPharmacy") {
                  // this.handleFile(this.currentData)
                }


                currentBtnVal.file_data['args'] = "uhid:" + this.formService.cardData.data.uhId + ",admissionId:" + this.formService.cardData.data.admissionId + ",primaryKeyIdentifier:" + this.currentData[0].refund_recipt_no + ",refund_recipt_no:" + this.currentData[0].refund_recipt_no + ",reportTemplateId:opReceiptRefund,userPrint:Y"
                this.handleFile(currentBtnVal, { data:this.currentData }, (response) => {
                  if (!response) {
                    this.formService.alerts.error("Print Error");
                  }
                  this.formService.baseService.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
                });
              }
              else {
                this.loader.hideSpinner();
                this.formService.alerts.error("Incorrect PIN");
              }
              console.log("event to be passed in complete order", event);
            }
            else if (res.errCode == -1) {
              this.formService.alerts.error("Please generate your Pin by clicking on profile icon at the top right corner")
            }
            this.loader.hideSpinner();
          }
        })
      } else {
        //TODO Popup closed without pin
      }
    });
  }

  beforeSubmitValidation(obj?: any, cb?: any) {
    if(obj.currentForm.controls.payment_mode_code && this.comp == "opRefund"){
      this.payment_mode_display = obj.currentForm.controls.payment_mode_display.value
      this.payment_mode_code = obj.currentForm.controls.payment_mode_code.value
      this.bank_name = obj.currentForm.controls.bank_name.value
      this.bank_code = obj.currentForm.controls.bank_code.value
      this.amount = obj.currentForm.controls.amount.value
      this.request_transaction_no = obj.currentForm.controls.request_transaction_no.value
      this.currency_exchange_remark = obj.currentForm.controls.currency_exchange_remark.value

    }
    cb(true)
  }


  isNumberKey(evt, result) {

    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode != 58 || (charCode == 58 && evt.target.value.includes(":"))) && charCode != 45 && charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57)) {
      return false;
    }
    else {
      return true;
    }
  }

}



